module.exports = __webpack_public_path__ + "img/menu_icon_mine_selected.e9ff0f00.png";